// /**
//  * Order detail -CSV
//  */

// React
import {Button} from '@material-ui/core';
import React from 'react';
import {CSVLink} from 'react-csv';
import {Order} from '../orders/interfaces';

type Props = {
  data: Order[];
  loading: boolean;
};

function CSV(props: Props) {
  const flattData = (data: any) => {
    return data.map((item: any) => {
      return {
        orderItemId: item.id,
        productName: item.productName,
        productCode: item.productCode,
        productId: item.id,
        variantCode: item.variantCode,
        variantId: item.variantId,
        amount: item.amount,
      };
    });
  };

  return (
    <CSVLink
      data={flattData(props.data)}
      filename="Orders.csv"
      style={{
        marginRight: '8px',
        textDecoration: 'none',
      }}
    >
      <Button variant="outlined" color="primary" size="medium">
        CSV
      </Button>
    </CSVLink>
  );
}

export default CSV;
